export function phoneNumberValidator() {
    return function (control) {
        var patten = new RegExp(/0[127]\d{8,9}/);
        return (!control.value || patten.test(control.value)) ? null : { validPhoneNumber: { value: control.value } };
    };
}
var ValidPhoneNumberDirective = (function () {
    function ValidPhoneNumberDirective() {
    }
    ValidPhoneNumberDirective.prototype.validate = function (control) {
        return phoneNumberValidator()(control);
    };
    return ValidPhoneNumberDirective;
}());
export { ValidPhoneNumberDirective };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/shared/valid-phone-number.directive.ts.pre-build-optimizer.js